/**
 * Coerce a nullish value to undefined, or return the value as is.
 *
 * @param val An unknown value
 * @return The value if it is not nullish, otherwise undefined
 */
export function nullishToUndefined(val) {
    return val !== null && val !== void 0 ? val : undefined;
}
//# sourceMappingURL=nullishToUndefined.js.map